export const partyHeaders: Record<string, string> = {
  Company: 'Company',
  FirstName: 'First Name',
  MiddleName: 'Middle Name',
  LastName: 'Last Name',
  Title: 'Title',
  Street: 'Street',
  City: 'City',
  State: 'State',
  Zip: 'Zip',
  LicenseNo: 'License No',
  CompanyLicenseNo: 'Company License No',
  BranchID: 'Branch ID',
  HomePhone: 'Home Phone',
  OtherPhone: 'Other Phone',
  Pager: 'Pager',
  WorkPhone: 'Work Phone',
  MobilePhone: 'Mobile Phone',
  Fax: 'Fax',
  EMail: 'Email',
  EMail2: 'Email 2',
  EMail3: 'Email 3',
  CompanyEIN: 'Company EIN',
  CompanyNMLSID: 'Company NMLS ID',
  ContactNMLSID: 'Contact NMLS ID',
  Notes: 'Notes',
}

export const tmoReports: Record<string, string> = {
  borrowerLateReport: 'BORROWER LATE REPORT',
  propertyInsuranceExpirationReport: 'PROPERTY INSURANCE EXPIRATION REPORT',
  loanAgingTrialBalanceReport: 'LOAN AGING TRIAL BALANCE REPORT',
}
